import PropTypes from 'prop-types';

export const TickCircleIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={'custom-icon ' + className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2286 10.068C17.708 9.61042 17.7257 8.85083 17.2681 8.37143C16.8104 7.89203 16.0509 7.87437 15.5715 8.33197L10.5334 13.1411L8.4286 11.132C7.9492 10.6744 7.18961 10.692 6.732 11.1714C6.27439 11.6508 6.29206 12.4104 6.77145 12.868L10.5334 16.4589L17.2286 10.068Z"
        fill="#14B814"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48809 6.48809 2 12 2C17.5119 2 22 6.48809 22 12C22 17.5119 17.5119 22 12 22C6.48809 22 2 17.5119 2 12ZM4.05952 12C4.05952 16.381 7.61905 19.9405 12 19.9405C16.3929 19.9405 19.9405 16.381 19.9405 12C19.9405 7.61905 16.3929 4.05952 12 4.05952C7.60714 4.05952 4.05952 7.61905 4.05952 12Z"
        fill="#14B814"
      />
    </svg>
  );
};

TickCircleIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
